import {Route, Routes} from 'react-router-dom'
import {Login} from './components/Login'
import {ResetPassword} from './components/ResetPassword'
import {AuthLayout} from './AuthLayout'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
       <Route path='reset-password/:token' element={<ResetPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
